var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("BjRouteTabs", {
        attrs: { "route-list": _vm.STRATEGY_SOURCE_ROUTE_LIST },
      }),
      _c("BjPage", {
        ref: "BjPage",
        attrs: {
          "query-params": _vm.queryParams,
          "col-span": _vm.colSpan,
          "get-action": _vm.queryApi,
          serial: _vm.serial,
          selection: _vm.selection,
        },
        on: {
          handleSelectionChange: _vm.handleSelectionChange,
          showSetting: _vm.SortableTable.show,
          "header-dragend": _vm.SortableTable.handleHeaderDragend,
          "header-contextmenu": _vm.SortableTable.handleHeaderContextmenu,
        },
        scopedSlots: _vm._u([
          {
            key: "tableOperation",
            fn: function (tableOperationProp) {
              return [
                _c(
                  "div",
                  [
                    _c(
                      "el-tabs",
                      {
                        attrs: { type: "card" },
                        on: { "tab-click": _vm.handleClick },
                        model: {
                          value: _vm.activeName,
                          callback: function ($$v) {
                            _vm.activeName = $$v
                          },
                          expression: "activeName",
                        },
                      },
                      [
                        _c("el-tab-pane", {
                          attrs: {
                            label: _vm.$t(
                              "SettingOrderSourceStrategyParcel.title"
                            ),
                            name: "0",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "div",
                  [
                    _c(
                      "el-col",
                      [
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "permission",
                                rawName:
                                  "v-permission:SettingOrderSourceStrategyParcel_Delete",
                                arg: "SettingOrderSourceStrategyParcel_Delete",
                              },
                            ],
                            attrs: {
                              type: "primary",
                              disabled: tableOperationProp.notSelected,
                            },
                            on: { click: _vm.onDeleteSelected },
                          },
                          [_vm._v(_vm._s(_vm.$t("delText")))]
                        ),
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "permission",
                                rawName:
                                  "v-permission:SettingOrderSourceStrategyParcel_Add",
                                arg: "SettingOrderSourceStrategyParcel_Add",
                              },
                            ],
                            staticClass: "main-btn",
                            attrs: { type: "primary" },
                            on: { click: _vm.onAdd },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t("SettingOrderSourceStrategyParcel.rule")
                              )
                            ),
                          ]
                        ),
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "permission",
                                rawName:
                                  "v-permission:SettingOrderSourceStrategyParcel_Set1",
                                arg: "SettingOrderSourceStrategyParcel_Set1",
                              },
                            ],
                            attrs: { type: "primary" },
                            on: { click: _vm.onExcludeSet },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "SettingOrderSourceStrategyParcel.condition"
                                )
                              )
                            ),
                          ]
                        ),
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "permission",
                                rawName:
                                  "v-permission:SettingOrderSourceStrategyParcel_Set2",
                                arg: "SettingOrderSourceStrategyParcel_Set2",
                              },
                            ],
                            attrs: { type: "primary", disabled: "" },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t("SettingOrderSourceStrategyParcel.pack")
                              )
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
          },
          {
            key: "tableColumn",
            fn: function () {
              return [
                _vm._l(_vm.dropCols, function (col, index) {
                  return [
                    col.prop !== "bjTableAction"
                      ? _c(
                          "el-table-column",
                          {
                            key:
                              "col_" +
                              index +
                              "_" +
                              col.prop +
                              "_" +
                              (col.width || "auto"),
                            attrs: {
                              prop: col.prop,
                              label: col.label,
                              width: col.width || "auto",
                              fixed: col.fixed || false,
                              align: "center",
                              "class-name": "item",
                              "show-overflow-tooltip":
                                col.prop !== "bjTableAction",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      false
                                        ? void 0
                                        : col.prop === "splitNum"
                                        ? [
                                            _vm.splitNumIds.includes(
                                              scope.row.id
                                            )
                                              ? _c("BjInputNumber", {
                                                  attrs: {
                                                    placeholder: _vm.$t(
                                                      "SettingOrderSourceStrategyParcel.unlimited"
                                                    ),
                                                    "not-auto-zero": "",
                                                    clearable: "",
                                                  },
                                                  model: {
                                                    value: scope.row[col.prop],
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        scope.row,
                                                        col.prop,
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "scope.row[col.prop]",
                                                  },
                                                })
                                              : _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      scope.row[col.prop]
                                                        ? scope.row[col.prop]
                                                        : _vm.$t(
                                                            "SettingOrderSourceStrategyParcel.all"
                                                          )
                                                    )
                                                  ),
                                                ]),
                                          ]
                                        : _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("timeFilters")(
                                                  scope.row[col.prop],
                                                  scope.row[col.prop]
                                                )
                                              )
                                            ),
                                          ]),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          },
                          [
                            col.prop === "splitNum"
                              ? _c("template", { slot: "header" }, [
                                  _c(
                                    "span",
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "SettingOrderSourceStrategyParcel.table.subcontract"
                                            )
                                          ) +
                                          " "
                                      ),
                                      _c(
                                        "el-tooltip",
                                        {
                                          attrs: {
                                            effect: "dark",
                                            placement: "top-start",
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              attrs: { slot: "content" },
                                              slot: "content",
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "SettingOrderSourceStrategyParcel.hint1"
                                                    )
                                                  )
                                              ),
                                              _c("br"),
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "SettingOrderSourceStrategyParcel.hint2"
                                                    )
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                          _c("i", {
                                            staticClass: "el-icon-question",
                                          }),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ])
                              : _vm._e(),
                          ],
                          2
                        )
                      : _vm._e(),
                    col.prop === "bjTableAction"
                      ? _c("el-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            prop: col.prop,
                            label: col.label,
                            width: col.width || "auto",
                            fixed: col.fixed || "right",
                            align: "center",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (props) {
                                  return [
                                    !_vm.splitNumIds.includes(props.row.id)
                                      ? _c(
                                          "el-button",
                                          {
                                            directives: [
                                              {
                                                name: "permission",
                                                rawName:
                                                  "v-permission:SettingOrderSourceStrategyParcel_Edit",
                                                arg: "SettingOrderSourceStrategyParcel_Edit",
                                              },
                                            ],
                                            attrs: { type: "text" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.onEdit(props.row)
                                              },
                                            },
                                          },
                                          [_vm._v(_vm._s(_vm.$t("editText")))]
                                        )
                                      : _vm._e(),
                                    _vm.splitNumIds.includes(props.row.id)
                                      ? _c(
                                          "el-button",
                                          {
                                            directives: [
                                              {
                                                name: "permission",
                                                rawName:
                                                  "v-permission:SettingOrderSourceStrategyParcel_Edit",
                                                arg: "SettingOrderSourceStrategyParcel_Edit",
                                              },
                                            ],
                                            attrs: { type: "text" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.onSave(props.row)
                                              },
                                            },
                                          },
                                          [_vm._v(_vm._s(_vm.$t("saveText")))]
                                        )
                                      : _vm._e(),
                                    _vm.splitNumIds.includes(props.row.id)
                                      ? _c(
                                          "el-button",
                                          {
                                            directives: [
                                              {
                                                name: "permission",
                                                rawName:
                                                  "v-permission:SettingOrderSourceStrategyParcel_Edit",
                                                arg: "SettingOrderSourceStrategyParcel_Edit",
                                              },
                                            ],
                                            attrs: { type: "text" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.onCancel(props.row)
                                              },
                                            },
                                          },
                                          [_vm._v(_vm._s(_vm.$t("cancelText")))]
                                        )
                                      : _vm._e(),
                                    !_vm.splitNumIds.includes(props.row.id)
                                      ? _c(
                                          "el-button",
                                          {
                                            directives: [
                                              {
                                                name: "permission",
                                                rawName:
                                                  "v-permission:SettingOrderSourceStrategyParcel_Delete",
                                                arg: "SettingOrderSourceStrategyParcel_Delete",
                                              },
                                            ],
                                            attrs: { type: "text" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.onDelete(props.row)
                                              },
                                            },
                                          },
                                          [_vm._v(_vm._s(_vm.$t("delText")))]
                                        )
                                      : _vm._e(),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : _vm._e(),
                  ]
                }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c("BjDialogList", {
        ref: "dialogList",
        attrs: {
          config: _vm.$BjDialogListConfig.skuDefault(),
          width: "85%",
          "right-span": 10,
          "show-tags": false,
          multiple: "",
          "before-confirm": _vm.beforeConfirm,
        },
        on: { confirm: _vm.onConfirmDialogList },
        scopedSlots: _vm._u([
          {
            key: "right",
            fn: function (dialogProps) {
              return [
                _c(
                  "el-row",
                  [
                    _c(
                      "el-col",
                      { staticClass: "text-right" },
                      [
                        _c(
                          "el-button",
                          {
                            staticClass: "mb20",
                            attrs: { type: "danger" },
                            on: { click: _vm.onRightTableDeleteSelected },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "SettingOrderSourceStrategyParcel.batchDeletion"
                                )
                              )
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                dialogProps.visible
                  ? _c(
                      "vxe-table",
                      {
                        ref: "RightTable",
                        attrs: {
                          data: dialogProps.pagesSelectedRows,
                          "max-height": dialogProps.maxHeight - 48,
                          border: "",
                          "header-cell-style": _vm.$rowStyle.DEFAULT,
                          "empty-text": _vm.$t("table.emptyText"),
                        },
                        on: {
                          "checkbox-all": _vm.handleRightSelectionChange,
                          "checkbox-change": _vm.handleRightSelectionChange,
                        },
                      },
                      [
                        _c("el-table-column", {
                          attrs: {
                            type: "selection",
                            width: "50",
                            align: "center",
                          },
                        }),
                        _c("el-table-column", {
                          attrs: {
                            label: _vm.$t("table.countText"),
                            type: "index",
                            width: "80",
                            align: "center",
                          },
                        }),
                        _c("el-table-column", {
                          attrs: {
                            label: _vm.$t(
                              "SettingOrderSourceStrategyParcel.table.skuCoding"
                            ),
                            width: "120",
                            prop: "skuCode",
                            align: "center",
                          },
                        }),
                        _c("el-table-column", {
                          attrs: {
                            label: _vm.$t(
                              "SettingOrderSourceStrategyParcel.table.skuName"
                            ),
                            width: "120",
                            prop: "skuName",
                            align: "center",
                          },
                        }),
                        _c(
                          "el-table-column",
                          {
                            attrs: {
                              label: _vm.$t(
                                "SettingOrderSourceStrategyParcel.table.subcontract"
                              ),
                              prop: "splitNum",
                              width: "180",
                              align: "center",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (props) {
                                    return [
                                      _c("BjInputNumber", {
                                        attrs: {
                                          placeholder: _vm.$t(
                                            "SettingOrderSourceStrategyParcel.unlimited"
                                          ),
                                          "not-auto-zero": "",
                                          clearable: "",
                                        },
                                        model: {
                                          value: props.row.splitNum,
                                          callback: function ($$v) {
                                            _vm.$set(props.row, "splitNum", $$v)
                                          },
                                          expression: "props.row.splitNum",
                                        },
                                      }),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          },
                          [
                            _c("template", { slot: "header" }, [
                              _c(
                                "span",
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t(
                                          "SettingOrderSourceStrategyParcel.table.subcontract"
                                        )
                                      ) +
                                      " "
                                  ),
                                  _c(
                                    "el-tooltip",
                                    {
                                      attrs: {
                                        effect: "dark",
                                        placement: "top-start",
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          attrs: { slot: "content" },
                                          slot: "content",
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t(
                                                  "SettingOrderSourceStrategyParcel.hint1"
                                                )
                                              )
                                          ),
                                          _c("br"),
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t(
                                                  "SettingOrderSourceStrategyParcel.hint2"
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                      _c("i", {
                                        staticClass: "el-icon-question",
                                      }),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ]),
                          ],
                          2
                        ),
                        _c("el-table-column", {
                          attrs: {
                            label: _vm.$t("table.operationText"),
                            width: "100",
                            align: "center",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (props) {
                                  return [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { type: "text" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.onRightTableDelete(
                                              props.row,
                                              props.$index
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v(_vm._s(_vm.$t("delText")))]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ]
            },
          },
        ]),
      }),
      _c("dialogForm", { ref: "dialogForm" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }